module.exports = __webpack_public_path__ + "img/icn-01.758262a7.png";